import { css, keyframes } from '@emotion/react';
import styled from '@emotion/styled';
import { AnimatePresence, motion } from 'motion/react';
import { type FC, useEffect, useState } from 'react';

export const LoadingIndicator: FC = () => {
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    const handleDelayed = () => setIsLoading(true);
    const handleComplete = () => setIsLoading(false);

    window.addEventListener('routeUpdateDelayed', handleDelayed);
    window.addEventListener('routeUpdateComplete', handleComplete);

    return () => {
      window.removeEventListener('routeUpdateDelayed', handleDelayed);
      window.removeEventListener('routeUpdateComplete', handleComplete);
    };
  }, []);

  return (
    <AnimatePresence>
      {isLoading && (
        <Overlay
          key="loading-overlay"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.2 }}
        >
          <Spinner />
        </Overlay>
      )}
    </AnimatePresence>
  );
};

const Overlay = styled(motion.div)`
  position: fixed;
  inset: 0;
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: none;
`;

const spin = keyframes`
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
`;

const Spinner = styled.div`
  width: 40px;
  height: 40px;
  border: 3px solid rgba(0, 0, 0, 0.15);
  border-top-color: #000;
  border-radius: 50%;
  ${css`
    animation: ${spin} 0.7s linear infinite;
  `}
`;

export default LoadingIndicator;
